import { makeStyles } from "@material-ui/core/styles"

export default makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: "10px",
  },
  root_form: {
    display: "grid",
  },
  text_field: {
    width: "100%",
    marginBottom: "2px"
  },
  select: {
    height: "23px",
    marginBottom: "2px"
  },
  file_input_wrapper: {
    "marginBottom": "2px"
  },
  file_input: {
  }
}));
